import { useMutation } from 'react-query';
import {
  invalidateFinancialPlanQuery,
  invalidateLongevityAnalysis,
  invalidateMarketScenariosQuery,
  invalidateMonteCarloQuery,
  invalidateSocialSecurity,
} from '../../../../../helpers/legacyWhatIfsFinancialPlanHelpers';
import { authFetch } from '../../../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../../../CommonUtils/httpBodyOptions';
import { urlWithParams } from '../../../../../../../CommonUtils/urlWithParams';
import { SocialSecurityStrategy, SocialSecurityWhatIf } from './types';
import { bumpSocialSecurityWhatIfRefresh } from './useSocialSecurityWhatIfRefresh';

export interface ApplySocialSecurityStrategyToPlanParams {
  clientId: number;
  fpId: string;
  strategy: SocialSecurityStrategy;
  body?: SocialSecurityWhatIf[];
}

export interface ApplySocialSecurityStrategyToPlanResponse {
  Success: boolean;
  AlreadyApplied: boolean;
  Message: string;
  Strategy: SocialSecurityStrategy;
  AppliedAges: {
    PrincipalAge: number;
    SpouseAge: number | null;
    UseFraPrincipal: boolean;
    UseFraSpouse: boolean;
  };
}

const APPLY_URL = '/Consumer/OptimizeSocialSecurity/ApplySocialSecurityStrategyToPlan';

export const applySocialSecurityStrategyToPlan = ({
  clientId,
  fpId,
  strategy,
  body,
}: ApplySocialSecurityStrategyToPlanParams): Promise<ApplySocialSecurityStrategyToPlanResponse> =>
  authFetch(urlWithParams(APPLY_URL, { clientId, fpId, strategy }), {
    method: 'POST',
    ...(body != null ? httpBodyOptions(body, true) : {}),
  });

export const useApplySocialSecurityStrategyToPlanMutation = () => {
  return useMutation(applySocialSecurityStrategyToPlan, {
    async onSuccess(_, { clientId, fpId }) {
      await Promise.all([
        invalidateFinancialPlanQuery({ clientId, fpId }),
        invalidateSocialSecurity({ clientId, fpId }),
        invalidateMonteCarloQuery({ clientId, fpId }),
        invalidateLongevityAnalysis({ clientId, fpId }),
        invalidateMarketScenariosQuery({ clientId, fpId }),
      ]);
      bumpSocialSecurityWhatIfRefresh(clientId, fpId);
    },
  });
};
